"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.parseRGBA = void 0;

var parseRGBA = function parseRGBA(rgbaString) {
  var color = {
    a: 1
  };
  var attrs = rgbaString.match(/rgb[a]?\((.*)\)/)[1].split(',');
  color.r = parseInt(attrs[0]);
  color.g = parseInt(attrs[1]);
  color.b = parseInt(attrs[2]);
  if (attrs[3]) color.a = parseFloat(attrs[3]);
  return color;
};

exports.parseRGBA = parseRGBA;
var _default = parseRGBA;
exports["default"] = _default;